import InstantLeadCalls from './InstantLeadCalls';

export default InstantLeadCalls;
